import { RatePlanWithDiscount } from './hasRatePlanActiveDiscounts';

const isRatePlanChargeOutdated = (
  ratePlanCharge: Pick<RatePlanWithDiscount, 'effectiveEndDate'>,
  currentRatePlanDate: string,
) => {
  const { effectiveEndDate } = ratePlanCharge;
  if (effectiveEndDate === null) {
    return false;
  }
  return effectiveEndDate.localeCompare(currentRatePlanDate) < 0;
};

export default isRatePlanChargeOutdated;
